import cx from 'classnames';
import type { VoidFunctionComponent } from 'react';

import Button from '../../../generic/Button/Button';
import FallbackImage from '../../../generic/FallbackImage';
import DocsLink from '../../../generic/Link/DocsLink';
import SupportLink from '../../../generic/Link/SupportLink';
import Text from '../../../generic/Text';

import styles from '../dependencies.module.less';

export const NoResults: VoidFunctionComponent<{ onResetButtonClick: () => void }> = ({ onResetButtonClick }) => (
  <div className={styles.Fallbacks}>
    <FallbackImage
      src="no-results"
      alt="No issues found"
      hasPadding
    >
      <div>We couldn&apos;t find any results.</div>
      <Button
        type="text"
        size="large"
        onClick={onResetButtonClick}
      >
        Reset filters
      </Button>
    </FallbackImage>
  </div>
);

export const NoDependencies: VoidFunctionComponent = () => (
  <div className={cx(styles.Fallbacks, styles.NoDependencies)}>
    <Text.H1>Looks like there aren’t any dependencies here.</Text.H1>
    <Text>
      This project does not have any dependencies.
      If the project is being analyzed they will appear once the analysis is complete.
      If you feel this is a mistake take a look our <DocsLink to="/">documentation</DocsLink> or <SupportLink>reach out to our team</SupportLink> for help.
    </Text>
  </div>
);

export const Error: VoidFunctionComponent = () => (
  <div className={styles.Fallbacks}>
    <FallbackImage
      src="error-plug"
      alt="Network error"
    >
      <div>Oops! There was an error.</div>
      <div>Please try again in a bit.</div>
    </FallbackImage>
  </div>
);
